import React from 'react';

const Frase = ({ frase }) => {
  return <div className='alert alert-dark mt-3'>{frase}</div>;
};

export default Frase;
